var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompaniesInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 13.3333H15.4V15.5556H17.6M17.6 8.88889H15.4V11.1111H17.6M19.8 17.7778H11V15.5556H13.2V13.3333H11V11.1111H13.2V8.88889H11V6.66667H19.8M8.8 4.44444H6.6V2.22222H8.8M8.8 8.88889H6.6V6.66667H8.8M8.8 13.3333H6.6V11.1111H8.8M8.8 17.7778H6.6V15.5556H8.8M4.4 4.44444H2.2V2.22222H4.4M4.4 8.88889H2.2V6.66667H4.4M4.4 13.3333H2.2V11.1111H4.4M4.4 17.7778H2.2V15.5556H4.4M11 4.44444V0H0V20H22V4.44444H11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesInactiveIcon);
export default __webpack_public_path__ + "static/media/companiesInactiveIcon.cd73b2f10792f76bc95248d723d33b29.svg";
export { ForwardRef as ReactComponent };